module.exports = __webpack_public_path__ + "img/1738805179046.1894c352.png";